const documentReviewManagerKPIs = [
    {
        "uuid": "1",
        "appType": "初次申請",
        "projectManager": "初核員A",
        "appQuantity": 2,
        "sentTimes": 2,
        "reviewCorrectRate": 50,
        "timeComplianceRate": 50,
        "reviewComments": "1.A21100211 玉米粉為進口品應提供輸入許可通知\n" +
            "2.A21100211黑豆無基因改造問題，不需要求提供非基因改造報告\n",
    },
    {
        "uuid": "2",
        "appType": "增列評鑑場所",
        "projectManager": "初核員A",
        "appQuantity": 12,
        "sentTimes": 24,
        "reviewCorrectRate": 91.7,
        "timeComplianceRate": 91.7,
        "reviewComments": "",
    },
    {
        "uuid": "3",
        "appType": "展延",
        "projectManager": "初核員A",
        "appQuantity": 20,
        "sentTimes": 30,
        "reviewCorrectRate": 90,
        "timeComplianceRate": 80,
        "reviewComments": "",
    },
    {
        "uuid": "5",
        "appType": "初次申請",
        "projectManager": "初核員B",
        "appQuantity": 1,
        "sentTimes": 1,
        "reviewCorrectRate": 100,
        "timeComplianceRate": 100,
        "reviewComments": "",
    },
    {
        "uuid": "6",
        "appType": "增列評鑑場品",
        "projectManager": "初核員B",
        "appQuantity": 1,
        "sentTimes": 1,
        "reviewCorrectRate": 50,
        "timeComplianceRate": 50,
        "reviewComments": "",
    },
    {
        "uuid": "7",
        "appType": "展延",
        "projectManager": "初核員B",
        "appQuantity": 10,
        "sentTimes": 10,
        "reviewCorrectRate": 100,
        "timeComplianceRate": 100,
        "reviewComments": "",
    },
    {
        "uuid": "8",
        "appType": "異動",
        "projectManager": "初核員B",
        "appQuantity": 2,
        "sentTimes": 4,
        "reviewCorrectRate": 50,
        "timeComplianceRate": 50,
        "reviewComments": "",
    },
    {
        "uuid": "9",
        "appType": "標示審查",
        "projectManager": "初核員B",
        "appQuantity": 2,
        "sentTimes": 2,
        "reviewCorrectRate": 100,
        "timeComplianceRate": 100,
        "reviewComments": "",
    },
]

export default documentReviewManagerKPIs;